import { match } from "ts-pattern";
import { colorDataSchema } from "./data";
import {
  ControlDataTypeKey,
  Types,
  Schema
} from "./prop-controllers";
import { z } from "zod";
const shadowDataSchema = z.object({
  color: colorDataSchema.nullable().optional(),
  blurRadius: z.number().optional(),
  spreadRadius: z.number().optional(),
  offsetX: z.number().optional(),
  offsetY: z.number().optional(),
  inset: z.boolean().optional()
});
const shadowsDataSchema = z.array(
  z.object({
    id: z.string(),
    payload: shadowDataSchema
  })
);
const responsiveShadowsDataSchema = Schema.responsiveValue(shadowsDataSchema);
const shadowsPropControllerDataV0Schema = responsiveShadowsDataSchema;
const ShadowsPropControllerDataV1Type = "prop-controllers::shadows::v1";
const shadowsPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(ShadowsPropControllerDataV1Type),
  value: responsiveShadowsDataSchema
});
const shadowsPropControllerDataSchema = z.union([
  shadowsPropControllerDataV0Schema,
  shadowsPropControllerDataV1Schema
]);
const ShadowsPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::shadows::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::shadows::format::responsive-value"
};
function Shadows(options = {}) {
  return { type: Types.Shadows, version: 1, options };
}
Shadows.Format = ShadowsPropControllerFormat;
function getShadowsPropControllerDataResponsiveShadowsData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: ShadowsPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createShadowsPropControllerDataFromResponsiveShadowsData(definition, responsiveShadowsData) {
  return match(definition).with(
    { version: 1 },
    () => ({
      [ControlDataTypeKey]: ShadowsPropControllerDataV1Type,
      value: responsiveShadowsData
    })
  ).otherwise(() => responsiveShadowsData);
}
function getShadowsPropControllerDataSwatchIds(data) {
  return getShadowsPropControllerDataResponsiveShadowsData(data)?.flatMap((override) => override.value).map((item) => item.payload.color?.swatchId).filter(
    (swatchId) => swatchId != null
  ) ?? [];
}
function copyResponsiveShadowsData(data, context) {
  return data.map((override) => ({
    ...override,
    value: override.value.map((item) => {
      const { color } = item.payload;
      if (color == null)
        return item;
      return {
        ...item,
        payload: {
          ...item.payload,
          color: {
            ...color,
            swatchId: context.replacementContext.swatchIds.get(color.swatchId) ?? color.swatchId
          }
        }
      };
    })
  }));
}
function copyShadowsPropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with(
    { [ControlDataTypeKey]: ShadowsPropControllerDataV1Type },
    (v1) => ({
      [ControlDataTypeKey]: ShadowsPropControllerDataV1Type,
      value: copyResponsiveShadowsData(v1.value, context)
    })
  ).otherwise((v0) => copyResponsiveShadowsData(v0, context));
}
export {
  Shadows,
  ShadowsPropControllerFormat,
  copyShadowsPropControllerData,
  createShadowsPropControllerDataFromResponsiveShadowsData,
  getShadowsPropControllerDataResponsiveShadowsData,
  getShadowsPropControllerDataSwatchIds,
  shadowsPropControllerDataSchema
};
//# sourceMappingURL=shadows.js.map